import { createSelector } from 'reselect';

import { getOptimisticFavoriteCount } from '@/utility/getOptimisticFavoriteCount';

import { getUserFavorites } from '../favorites';
import { getListingData } from './page';

export const getListingFavoriteCount = createSelector(
  [getUserFavorites, getListingData],
  (favorites, listingData) => {
    const isFavorite = favorites.rentals.some(fav => fav.item_id === listingData?.id);
    return getOptimisticFavoriteCount(listingData, isFavorite);
  },
);
